import React, { useEffect, useRef } from "react";

export default function FuturesTicker({ theme = "light" }) {
  const containerRef = useRef(null);

  useEffect(() => {
    if (!containerRef.current) return;
    containerRef.current.innerHTML = "";

    const script = document.createElement("script");
    script.src = "https://s3.tradingview.com/external-embedding/embed-widget-ticker-tape.js";
    script.async = true;
    script.type = "text/javascript";
    script.innerHTML = JSON.stringify({
      "symbols": [
        { "proName": "OANDA:SPX500USD", "title": "S&P 500" },
        { "proName": "OANDA:NAS100USD", "title": "Nasdaq 100" },
        { "proName": "FOREXCOM:DJI", "title": "Dow Jones" },
        { "proName": "TVC:GOLD", "title": "Gold" },
        { "proName": "TVC:SILVER", "title": "Silver" },
        { "proName": "TVC:USOIL", "title": "Crude Oil" },
        { "proName": "FX:EURUSD", "title": "EUR/USD" }
      ],
      "colorTheme": theme,
      "isTransparent": false,
      "displayMode": "regular",
      "locale": "en"
    });
    containerRef.current.appendChild(script);

    return () => {
      if (containerRef.current) containerRef.current.innerHTML = "";
    };
  }, [theme]);

  return (
    <div className="mb-6 -mx-4">
      <div ref={containerRef} />
    </div>
  );
}
